import { Link } from "react-router-dom";

const Main = ({ title, context, btn, backimg }) => {
  return (
    <section className="main" style={{ backgroundImage: `url(${backimg})` }}>
      <div className="main__container">
        <h1>{title}</h1>
        <p>{context}</p>
        {btn && <Link to="/contact">{btn}</Link>}
      </div>
    </section>
  );
};

export default Main;
